<div *ngIf="pageLoading1" class="loader text-center">
	<img src="../../assets/img/loading.gif" />
	<p style="color: black;font-weight: bolder;">Loading...</p>
</div>
@if ((!uId && navbar.user?.tms_access?.create_recurring_task) || (uId && navbar.user?.tms_access?.edit_recurring_task))
{
<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<input class="form-control" [ngClass]="{'is-invalid':showError('sub_task')}" id="sub_task"
					formControlName="sub_task" placeholder="">
				<label for="sub_task">Task*</label>
			</div>
			<p *ngIf="showError('sub_task')" class="text-danger">
				<span *ngIf="f.sub_task.errors?.required">
					Required
				</span>
				<span *ngIf="f.sub_task.errors?.incorrect">
					{{customError.sub_task}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col">
			<div class="ng-select-material">
				<ng-select [items]="navbar.departmentList" bindValue="id" bindLabel="name" [clearable]="true"
					placeholder="Department*" formControlName="department_id" id="department_id" appearance="outline"
					[ngClass]="{'is-invalid':showError('department_id')}">
				</ng-select>
			</div>
			<p *ngIf="showError('department_id')" class="text-danger">
				<span *ngIf="f.department_id.errors?.required">
					Required
				</span>
				<span *ngIf="f.department_id.errors?.incorrect">
					{{customError.department_id}}
				</span>
			</p>
		</div>
		<div class="col">
			<div class="ng-select-material">
				<ng-select [items]="userList" bindValue="id" bindLabel="full_name" [clearable]="true"
					placeholder="Lead*" formControlName="lead_id" id="lead_id" appearance="outline"
					[ngClass]="{'is-invalid':showError('lead_id')}">
				</ng-select>
			</div>
			<p *ngIf="showError('lead_id')" class="text-danger">
				<span *ngIf="f.lead_id.errors?.required">
					Required
				</span>
				<span *ngIf="f.lead_id.errors?.incorrect">
					{{customError.lead_id}}
				</span>
			</p>
		</div>
		<div class="col">
			<div class="ng-select-material">
				<ng-select [items]="userList" bindValue="id" bindLabel="full_name" [clearable]="true"
					placeholder="Assigned To*" formControlName="assigned_id" id="assigned_id" appearance="outline"
					[ngClass]="{'is-invalid':showError('assigned_id')}">
				</ng-select>
			</div>
			<p *ngIf="showError('assigned_id')" class="text-danger">
				<span *ngIf="f.assigned_id.errors?.required">
					Required
				</span>
				<span *ngIf="f.assigned_id.errors?.incorrect">
					{{customError.assigned_id}}
				</span>
			</p>
		</div>
		<div class="col">
			<div class="ng-select-material">
				<ng-select [items]="recurringPattern" bindValue="value" bindLabel="name" [clearable]="true"
					placeholder="Pattern*" formControlName="recurrence_pattern" id="recurrence_pattern"
					appearance="outline" [ngClass]="{'is-invalid':showError('recurrence_pattern')}">
				</ng-select>
			</div>
			<p *ngIf="showError('recurrence_pattern')" class="text-danger">
				<span *ngIf="f.recurrence_pattern.errors?.required">
					Required
				</span>
				<span *ngIf="f.recurrence_pattern.errors?.incorrect">
					{{customError.recurrence_pattern}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<div class="form-floating">
				<textarea class="form-control" rows="3" [ngClass]="{'is-invalid':showError('notes')}" id="notes"
					formControlName="notes" placeholder=""></textarea>
				<label for="notes">Notes</label>
			</div>
			<p *ngIf="showError('notes')" class="text-danger">
				<span *ngIf="f.notes.errors?.required">
					Required
				</span>
				<span *ngIf="f.notes.errors?.incorrect">
					{{customError.notes}}
				</span>
			</p>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
			<button type="submit" class="btn btn-sm btn-primary me-1">
				<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
				<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
				Submit
			</button>
			<button type="button" class="btn btn-sm btn-secondary" (click)="clearForm();">Cancel</button>
		</div>
	</div>
</form>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}